const urls = {
    CLEARANCE_DOCUMENT_SUMMARY: 'clearance-documents/document-summary',
    CLEARANCE_DOCUMENT_BILL_OF_LADING: 'clearance-documents/bill-of-lading',
    CLEARANCE_DOCUMENT_CARGO_MANIFEST: 'clearance-documents/cargo-manifest',
    CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY: 'clearance-documents/certificate-of-quantity',
    CLEARANCE_DOCUMENT_DELIVERY_NOTE: 'clearance-documents/delivery-note',
    CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE: 'clearance-documents/goods-receipt-note',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS: 'clearance-documents/master-receipt-documents',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES: 'clearance-documents/master-receipt-samples',
    CLEARANCE_DOCUMENT_SHORE_TANK: 'clearance-documents/shore-tank',
    CLEARANCE_DOCUMENT_BILL_OF_LADING_ITEM: 'clearance-documents/bill-of-lading-item',
    CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_ITEM: 'clearance-documents/certificate-of-quantity-item',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_ITEM: 'clearance-documents/master-receipt-samples-item',
    CLEARANCE_DOCUMENT_CONVERSION_SERVICE: 'clearance-documents/conversion-service',
    CLEARANCE_DOCUMENT_COMBO: 'clearance-document-version-combo',
    CLEARANCE_DOCUMENT_PROPOSAL_VERSION: 'clearance-document-version/proposal-version',
    CLEARANCE_DOCUMENT_VERSION_CANCEL_AND_RECREATE: 'clearance-document-version/cancel-and-recreate',
    CLEARANCE_DOCUMENT_VERSION_CLOSE: 'clearance-document-version-close-version',
    CLEARANCE_DOCUMENT_VERSION: 'clearance-documents/clearance-version',
    CLEARANCE_DOCUMENT_SECTION_COMBO: 'masterdata/registry-document-section-combo',
    CLEARANCE_DOCUMENT_CARGO_MANIFEST_PRINT: 'clearance-documents/cargo-manifest-print',
    CLEARANCE_DOCUMENT_CARGO_MANIFEST_PRINT_PREVIEW: 'clearance-documents/cargo-manifest-print-preview',
    CLEARANCE_DOCUMENT_BILL_OF_LADING_PRINT: 'clearance-documents/bill-of-lading-print',
    CLEARANCE_DOCUMENT_BILL_OF_LADING_PRINT_PREVIEW: 'clearance-documents/bill-of-lading-print-preview',
    CLEARANCE_DOCUMENT_DELIVERY_NOTE_PRINT: 'clearance-documents/delivery-note-print',
    CLEARANCE_DOCUMENT_DELIVERY_NOTE_PRINT_PREVIEW: 'clearance-documents/delivery-note-print-preview',
    CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_PRINT: 'clearance-documents/certificate-of-quantity-print',
    CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_PRINT_PREVIEW: 'clearance-documents/certificate-of-quantity-print-preview',
    CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE_PRINT: 'clearance-documents/goods-receipt-print',
    CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE_PRINT_PREVIEW: 'clearance-documents/goods-receipt-print-preview',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS_PRINT: 'clearance-documents/master-receipt-documents-print',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS_PRINT_PREVIEW: 'clearance-documents/master-receipt-documents-print-preview',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_PRINT: 'clearance-documents/master-receipt-samples-print',
    CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_PRINT_PREVIEW: 'clearance-documents/master-receipt-samples-print-preview',
    CLEARANCE_DOCUMENT_SHORE_TANK_PRINT: 'clearance-documents/shore-tank-print',
    CLEARANCE_DOCUMENT_SHORE_TANK_PRINT_PREVIEW: 'clearance-documents/shore-tank-print-preview',
    CLEARANCE_DOCUMENT_DAA_PRINT: 'clearance-documents-daa-print',
    CLEARANCE_DOCUMENT_DAA_PRINT_PREVIEW: 'clearance-documents-daa-print-preview',
    CLEARANCE_DOCUMENT_DAA: 'clearance-documents/daa',
    CLEARANCE_DOCUMENT_DAA_SEND: 'clearance-documents-daa-send',
    CLEARANCE_DOCUMENT_READ_ARC: 'clearance-documents-read-arc',
    CLEARANCE_DOCUMENT_DAA_ISSUE_LOCAL_NUMBER: 'clearance-documents/daa-assign-number',
    CLEARANCE_DOCUMENT_PLZ_ASSIGN_DOC_NUMBER: 'clearance-documents/bill-of-lading-assign-doc-number',
    CLEARANCE_DOCUMENT_NP_ASSIGN_DOC_NUMBER: 'clearance-documents/delivery-note-assign-document-number',
    CLEARANCE_DOCUMENT_XAB_ASSIGN_DOC_NUMBER: 'clearance-documents/xab-assign-document-number',
    CLEARANCE_DOCUMENT_BEM_ASSIGN_DOC_NUMBER: 'clearance-documents/goods-receipt-assign-document-number',
    CLEARANCE_DOCUMENT_XAB: 'clearance-documents/xab',
    CLEARANCE_DOCUMENT_XAB_PRINT: 'clearance-documents/print-xab',
    CLEARANCE_DOCUMENT_XAB_PRINT_PREVIEW: 'clearance-documents/print-xab-preview',
    CLEARANCE_DOCUMENT_VERSION_DOCUMENT_WITHOUT_NUMBER: 'clearance-document-version-document-without-number',
    CLEARANCE_DOCUMENT_PRINT_FASCICOLATA: 'clearance-documents-print-fascicolata',
    CLEARANCE_DOCUMENT_LOTS_BY_VERSION: 'clearance-document-version/get-lot-list-by-version',
    CLEARANCE_DOCUMENT_REOPEN_VERSION: 'clearance-document-version-reopen-version',
    CLEARANCE_DOCUMENT_CHECK_BLACK_PRODUCTS: 'clearance-document-version/check-black-product'
}

import genericService from '../genericService';

export default {

    async getClearanceDocumentSummary(body, callback){
        await genericService.get(urls.CLEARANCE_DOCUMENT_SUMMARY, body).then(callback);
    },
    async getClearanceDocumentBillOfLading(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING, body).then(callback);
    },
    async getClearanceDocumentCargoManifest(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_CARGO_MANIFEST, body).then(callback);
    },
    async getClearanceDocumentCertificateOfQuantity(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY, body).then(callback);
    },
    async getClearanceDocumentDeliveryNote(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_DELIVERY_NOTE, body).then(callback);
    },
    async getClearanceDocumentGoodsReceiptNote(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE, body).then(callback);
    },
    async getClearanceDocumentMasterReceiptDocuments(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS, body).then(callback);
    },
    async getClearanceDocumentMasterReceiptSamples(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES, body).then(callback);
    },
    async getClearanceDocumentShoreTank(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_SHORE_TANK, body).then(callback);
    },
    async updateClearanceDocumentBillOfLading (body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING, body).then(callback);
    },
    async updateClearanceDocumentCargoManifest (body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_CARGO_MANIFEST, body).then(callback);
    },
    async updateClearanceDocumentCertificateOfQuantity(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY, body).then(callback);
    },
    async updateClearanceDocumentDeliveryNote(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_DELIVERY_NOTE, body).then(callback);
    },
    async updateClearanceDocumentGoodsReceiptNote(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE, body).then(callback);
    },
    async updateClearanceDocumentMasterReceiptDocuments(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS, body).then(callback);
    },
    async updateClearanceDocumentMasterReceiptSamples(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES, body).then(callback);
    },
    async updateClearanceDocumentShoreTank(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_SHORE_TANK, body).then(callback);
    },
    async updateClearanceDocumentBillOfLadingItem(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING_ITEM, body).then(callback);
    },
    async createClearanceDocumentBillOfLadingItem(body, callback){
        await genericService.post(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING_ITEM, body).then(callback);
    },
    async deleteClearanceDocumentBillOfLadingItem(id, callback){
        await genericService.delete(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING_ITEM, id).then(callback);
    },
    async updateClearanceDocumentCertificateOfQuantityItem(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_ITEM, body).then(callback);
    },
    async createClearanceDocumentCertificateOfQuantityItem(body, callback){
        await genericService.post(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_ITEM, body).then(callback);
    },
    async deleteClearanceDocumentCertificateOfQuantityItem(id, callback){
        await genericService.delete(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_ITEM, id).then(callback);
    },
    async updateClearanceDocumentMasterReceiptSamplesItem(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_ITEM, body).then(callback);
    },
    async createClearanceDocumentMasterReceiptSamplesItem(body, callback){
        await genericService.post(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_ITEM, body).then(callback);
    },
    async deleteClearanceDocumentMasterReceiptSamplesItem(id, callback){
        await genericService.delete(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_ITEM, id).then(callback);
    },
    async getClearanceDocumentConversion(body, callback){
        await genericService.get(urls.CLEARANCE_DOCUMENT_CONVERSION_SERVICE, body).then(callback);
    },
    async getClearanceDocumentVersion(body, callback){
        await genericService.get(urls.CLEARANCE_DOCUMENT_COMBO, body).then(callback);
    },
    async getClearanceDocumentProposalVersion(body, callback){
        await genericService.get(urls.CLEARANCE_DOCUMENT_PROPOSAL_VERSION, body).then(callback);
    },
    async cancelAndRecreateClearanceDocumentVersion(body, callback){
        await genericService.post(urls.CLEARANCE_DOCUMENT_VERSION_CANCEL_AND_RECREATE, body).then(callback);
    },
    async closeClearanceDocumentVersion(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_VERSION_CLOSE, body).then(callback);
    },
    async reopenClearanceDocumentVersion(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_REOPEN_VERSION, body).then(callback);
    },
    async createClearanceDocumentVersion(body, callback){
        await genericService.post(urls.CLEARANCE_DOCUMENT_VERSION, body).then(callback);
    },
    async getClearanceDocumentSectionCombo(body, callback){
        await genericService.get(urls.CLEARANCE_DOCUMENT_SECTION_COMBO, body).then(callback);
    },
    async getClearanceDocumentLotsByVersion(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_LOTS_BY_VERSION, body).then(callback);
    },
    async printClearanceDocumentCargoManifest(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_CARGO_MANIFEST_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentCargoManifest(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_CARGO_MANIFEST_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentBillOfLading(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentBillOfLading(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_BILL_OF_LADING_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentDeliveryNote(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_DELIVERY_NOTE_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentDeliveryNote(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_DELIVERY_NOTE_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentCertificateOfQuantity(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentCertificateOfQuantity(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_CERTIFICATE_OF_QUANTITY_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentGoodsReceiptNote(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentGoodsReceiptNote(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_GOOD_RECEIPT_NOTE_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentMasterReceiptDocuments(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentMasterReceiptDocuments(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_DOCUMENTS_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentMasterReceiptSamples(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentMasterReceiptSamples(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_MASTER_RECEIPT_SAMPLES_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentShoreTank(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_SHORE_TANK_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentShoreTank(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_SHORE_TANK_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentDAA(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_DAA_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentDAA(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_DAA_PRINT_PREVIEW, body).then(callback);
    },
    async printClearanceDocumentFascicolata(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_PRINT_FASCICOLATA, body).then(callback);
    },
    async getClearanceDocumentDAA(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_DAA, body).then(callback);
    },
    async updateClearanceDocumentDAA (body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_DAA, body).then(callback);
    },
    async sendClearanceDocumentDAA (body, callback){
        await genericService.post(urls.CLEARANCE_DOCUMENT_DAA_SEND, body).then(callback);
    },
    async getClearanceDocumentARC(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_READ_ARC, body).then(callback);
    },
    async assignClearanceDocumentDAALocalNumber(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_DAA_ISSUE_LOCAL_NUMBER, body).then(callback);
    },
    async assignClearanceDocumentPLZDocumentNumber(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_PLZ_ASSIGN_DOC_NUMBER, body).then(callback);
    },
    async assignClearanceDocumentNPDocumentNumber(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_NP_ASSIGN_DOC_NUMBER, body).then(callback);
    },
    async assignClearanceDocumentXABDocumentNumber(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_XAB_ASSIGN_DOC_NUMBER, body).then(callback);
    },
    async assignClearanceDocumentBEMDocumentNumber(body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_BEM_ASSIGN_DOC_NUMBER, body).then(callback);
    },
    async getClearanceDocumentXAB(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_XAB, body).then(callback);
    },
    async printClearanceDocumentXAB(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_XAB_PRINT, body).then(callback);
    },
    async printPreviewClearanceDocumentXAB(body, callback){
        await genericService.dowloadFile(urls.CLEARANCE_DOCUMENT_XAB_PRINT_PREVIEW, body).then(callback);
    },
    async updateClearanceDocumentXAB (body, callback){
        await genericService.put(urls.CLEARANCE_DOCUMENT_XAB, body).then(callback);
    },
    async getClearanceDocumentVersionWithoutNumber(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_VERSION_DOCUMENT_WITHOUT_NUMBER, body).then(callback);
    },
    async checkClearanceDocumentBlackProducts(body, callback){
        await genericService.getItem(urls.CLEARANCE_DOCUMENT_CHECK_BLACK_PRODUCTS, body).then(callback);
    },
}